/**
 * Skeleton components for Statistics page
 * MUST match exact dimensions of actual components to prevent CLS
 */

function StaticSkeleton({ className = "" }: { className?: string }) {
  return (
    <div className={`bg-muted/50 rounded ${className}`} aria-hidden="true" />
  );
}

function AnimatedSkeleton({ className = "" }: { className?: string }) {
  return (
    <div
      className={`animate-pulse bg-muted/60 rounded ${className}`}
      aria-hidden="true"
    />
  );
}

function SkeletonRow({ animated = false }: { animated?: boolean }) {
  const Skel = animated ? AnimatedSkeleton : StaticSkeleton;
  return (
    <tr className="border-b border-border/50">
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <Skel className="h-5 w-5 rounded-full" />
          <Skel className="h-4 w-24" />
        </div>
      </td>
      <td className="px-4 py-3">
        <Skel className="h-4 w-16" />
      </td>
      <td className="px-4 py-3 text-right">
        <Skel className="h-5 w-10 ml-auto" />
      </td>
      <td className="px-4 py-3 text-right">
        <Skel className="h-4 w-8 ml-auto" />
      </td>
      <td className="px-4 py-3 text-right">
        <Skel className="h-4 w-8 ml-auto" />
      </td>
      <td className="px-4 py-3 text-right">
        <Skel className="h-4 w-6 ml-auto" />
      </td>
      <td className="px-4 py-3 text-right">
        <Skel className="h-4 w-10 ml-auto" />
      </td>
      <td className="px-4 py-3 text-right">
        <Skel className="h-4 w-10 ml-auto" />
      </td>
      <td className="px-4 py-3 text-right">
        <Skel className="h-4 w-8 ml-auto" />
      </td>
      <td className="px-4 py-3 text-center">
        <Skel className="h-4 w-6 mx-auto" />
      </td>
      <td className="px-4 py-3 w-8" />
    </tr>
  );
}

export function StatisticsTableSkeleton({ rows = 20 }: { rows?: number }) {
  return (
    <div className="rounded-xl border border-border bg-card/50 overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 border-b border-border bg-muted/20 flex items-center gap-3">
        <AnimatedSkeleton className="h-5 w-32" />
        <StaticSkeleton className="h-5 w-24" />
      </div>
      <table className="w-full">
        <thead className="bg-muted/30 border-b border-border">
          <tr>
            <th className="text-left px-4 py-3">
              <StaticSkeleton className="h-3 w-14" />
            </th>
            <th className="text-left px-4 py-3">
              <StaticSkeleton className="h-3 w-12" />
            </th>
            {Array.from({ length: 7 }).map((_, i) => (
              <th key={i} className="text-right px-4 py-3">
                <StaticSkeleton className="h-3 w-8 ml-auto" />
              </th>
            ))}
            <th className="px-4 py-3 w-8" />
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <SkeletonRow key={i} animated={i === 0} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
